<script setup>
const props = defineProps({
  setCursor: Function,
});
</script>

<template>
  <div
    class="coworking-container flex justify-center relative"
    @mouseenter="
      setCursor(null, scrollTo, {
        'font-size': '14px',
        background: '#FFF',
        width: '25px',
        height: '25px',
        'z-index': '1',
        position: 'absolute',
      })
    "
  >
    <div class="max-w-7xl relative z-40">
      <div
        class="md:flex p-6 pt-20 md:pt-20 pb-12 md:p-12 md:px-6 lg:py-16 gap-32"
      >
        <h2 class="h1 mb-6 md:mb-0">{{ $t("spaces.coworking.title") }}</h2>
        <p class="!text-xl">
          {{ $t("spaces.coworking.subtitle") }}
        </p>
      </div>
      <div class="md:flex gap-24 p-6 md:p-8 items-center justify-center">
        <img
          src="/img/coworking_nejatraktivnejsi_praha1_staromestske_namesti_clenstvi.jpg"
          class="coworking-img"
        />
        <div>
          <div class="txt-l mb-1 md:mb-6 mt-6 md:mt-0">
            {{ $t("spaces.coworking.flexibleSpace.title") }}
          </div>
          <p class="md:max-w-xs">
            {{ $t("spaces.coworking.flexibleSpace.subtitle") }}
          </p>
        </div>
      </div>
      <div class="md:flex gap-24 p-6 md:p-8 items-center justify-center">
        <img
          src="/img/Pronajem_kancelare_designove_reprezentativni_Praha_Opero_byznys_hub.jpg"
          class="md:hidden mb-6 coworking-img"
        />
        <div class="md:ml-12">
          <div class="txt-l mb-1 md:mb-6">
            {{ $t("spaces.coworking.ownTable.title") }}
          </div>
          <p class="md:max-w-xs">
            {{ $t("spaces.coworking.ownTable.subtitle") }}
          </p>
        </div>
        <img
          src="/img/Pronajem_kancelare_designove_reprezentativni_Praha_Opero_byznys_hub.jpg"
          class="hidden md:block coworking-img"
        />
      </div>
      <div class="md:flex gap-24 p-6 md:p-8 items-center justify-center">
        <img
          src="/img/Vlastni_stul_opero_nejatraktivnejsi_pracovni_prostredi_praha_clenstvi.jpg"
          class="coworking-img mb-6 md:mb-0"
        />
        <div>
          <div class="txt-l mb-1 md:mb-6">
            {{ $t("spaces.coworking.office.title") }}
          </div>
          <p class="md:max-w-xs">
            {{ $t("spaces.coworking.office.subtitle") }}
          </p>
        </div>
      </div>

      <div class="flex justify-center mb-20 px-6 md:px-0">
        <NuxtLinkLocale to="membership">
          <button
            class="bg-transparent border rounded-full border-black text-black px-4 py-2 mt-6"
          >
            {{ $t("spaces.coworking.button") }}
          </button>
        </NuxtLinkLocale>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.coworking-container {
  margin-top: 48px;
  background: $color-primary;

  .txt-l {
    @media screen and (max-width: 1024px) {
      font-size: 28px !important;
    }
  }
}
.coworking-img {
  width: 459px;
  height: 254px;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    max-height: 200px;
  }
}
</style>
